<template>
  <DxForm>
    <DxGroupItem :col-count="3">
      <DxGroupItem :caption="$t('home.labels.notifications')">
        <DxItem>
          <DashboardMessage icon="product" 
                        :visible="isNewDevicesNotificationVisible" 
                        :text="newDevicesNotificationText"
                        @click="onNewDevicesNotificationClick" />
        </DxItem>
        <DxItem>
          <DashboardMessage icon="box" 
                        :visible="isNewComponentsNotificationVisible" 
                        :text="newComponentsNotificationText"
                        @click="onNewComponentsNotificationClick" />
        </DxItem>
      </DxGroupItem>
    </DxGroupItem>
  </DxForm>
</template>

<script setup>
import { DxBox, DxForm } from 'devextreme-vue';
import { DxGroupItem, DxItem } from 'devextreme-vue/cjs/form';
import DashboardMessage from '@/components/home/DashboardMessage.vue';
import { ref, onMounted } from 'vue';
import { useLocalization } from '@/locales/localization';
const localization = useLocalization();

import { useApiClient } from '@/utils/apiClient';
const api = useApiClient();

import { useRouter } from 'vue-router';
var router = useRouter();

import { useAuthStore } from '@/stores/auth';
const auth = useAuthStore();

const isNewDevicesNotificationVisible = ref(false);
const newDevicesNotificationText = ref(localization.t('home.notifications.newDevices', { p: 0 }));

function onNewDevicesNotificationClick(){
  router.push('/register/equipmentlist?isApproved=false');
}

const isNewComponentsNotificationVisible = ref(false);
const newComponentsNotificationText = ref(localization.t('home.notifications.newComponents', { p: 0 }));

function onNewComponentsNotificationClick(){
  router.push('/register/componentlist?isApproved=false');
}

onMounted(async () => {
  var result = await api.post('/register/equipmentlist', { isApproved: false, page: 1, pageSize: 1, isComponent: false });
  if(result.data.totalCount > 0 && auth.hasPermission('EquipmentListUnapproved')){
    isNewDevicesNotificationVisible.value = true;
    newDevicesNotificationText.value = localization.t('home.notifications.newDevices', { p: result.data.totalCount });
  }
  result = await api.post('/register/equipmentlist', { isApproved: false, page: 1, pageSize: 1, isComponent: true });
  if(result.data.totalCount > 0 && auth.hasPermission('EquipmentListUnapproved')){
    isNewComponentsNotificationVisible.value = true;
    newComponentsNotificationText.value = localization.t('home.notifications.newComponents', { p: result.data.totalCount });
  }
});
</script>